// extracted by mini-css-extract-plugin
export default {"flamegraphHeader":"Header_flamegraphHeader__+tYOe","row":"Header_row__cDN-r","flamegraphTitle":"Header_flamegraphTitle__Q2JtW"};